import { getRetinaSrcs, imageUrl } from '@helpers/image';
import { formatCurrency } from '@helpers/utils';
import { withRedux } from '@hoc/withRedux';
import SvgChevron from '@img/icons/chevron-right.svg';
import SvgTick from '@img/icons/tick.svg';
import { basket } from '@redux/slices/basket';
import { addProductToBasket } from '@redux/slices/basket/actions/addProductToBasket';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { isFulfilled } from '@reduxjs/toolkit';
import Button from '@stories/Components/Global/Buttons/Button/Button';
import LoadingIndicator from '@stories/Components/Global/LoadingIndicator/LoadingIndicator';
import QuantitySelector from '@stories/Components/Global/QuantitySelector/QuantitySelector';
import * as React from 'react';
import { toast } from 'react-toastify';
import S from './UpsellCard.styles';
const UpsellCard = (props) => {
    const dispatch = useAppDispatch();
    const { status: basketStatus, productId, onDate, offDate, items, version, } = useAppSelector((state) => state.basket);
    const [qty, setQty] = React.useState(1);
    const added = React.useMemo(() => items?.find((i) => i.kenticoSkuId === props.kenticoSkuId), [items?.length]);
    if (added) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.TopWrapper, null,
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { src: imageUrl(props.image, { width: 120, heightratio: 1 }, props.site), srcSet: getRetinaSrcs(props.image, 120, props.site).join(','), alt: props.image.altText ?? props.name })),
            React.createElement(S.TitlePriceWrapper, null,
                React.createElement("div", null,
                    React.createElement(S.Title, null, props.name),
                    React.createElement(S.Id, null, props.g42Id)),
                props.showPrice && (React.createElement(S.PriceWrapper, null,
                    React.createElement(S.Price, null, formatCurrency(props.price.incl)),
                    ' ',
                    React.createElement(S.Suffix, null, props.price.suffix))))),
        React.createElement(S.QuantityPriceWrapper, null,
            React.createElement(QuantitySelector, { value: qty, onDownPress: () => setQty(qty - 1), onUpPress: () => setQty(qty + 1), site: props.site, disabled: !!added }),
            React.createElement(Button, { site: props.site ?? 'ess', buttonType: props.site === 'ess' ? 'secondary' : 'default', ...(props.site === 'ess' ? { icon: React.createElement(SvgChevron, null) } : {}), onClick: () => addToBasket(props.id), disabled: !!added, ...(added ? { icon: React.createElement(SvgTick, null) } : {}) }, added ? 'Added' : props.buttonLabel)),
        basketStatus === 'submitting' && productId === props.id && (React.createElement(LoadingIndicator, { label: "Loading\u2026", layout: "absolute" }))));
    async function addToBasket(id) {
        dispatch(basket.actions.setStatus('submitting'));
        dispatch(basket.actions.setProductId(props.id));
        const result = await dispatch(addProductToBasket({
            products: [{ id, qty }],
            accessoryText: '',
            onDate,
            offDate,
            currentPageProductId: props.currentProductPageId,
        }));
        /** Show cart overlay, or error message */
        if (isFulfilled(result) && result.payload) {
            if (result.payload.errors) {
                toast(result.payload.errors.join(' '), { type: 'error' });
            }
            else {
                dispatch(basket.actions.setDrawerStatus('open-new'));
                dispatch(basket.actions.setBasketVersion(version + 1));
            }
        }
        else {
            dispatch(basket.actions.setStatus('rejected'));
            toast(`Error adding item to basket, please try again`, { type: 'error' });
        }
    }
};
export default withRedux(UpsellCard);
